var map = {
	"./HBS": 5944,
	"./HBS.js": 5944,
	"./oc-threejs/renderStats.hbs": 22277,
	"./oc-threejs/webxr/ArStage.hbs": 81707,
	"./oc-threejs/webxr/StorePage.hbs": 39024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17130;